import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
//引入接口RouteConfig
import { RouteConfig } from "vue-router";
//引入已有路由
import { constantRoutes } from "@/router";
//引入 store
import store from "@/store";

import { getCurrUserMenuTree,getCurrUserResources,teacherUserMenuTreeList} from '../../api/login'

export interface IPermissionState {
  routes: RouteConfig[];
  dynamicRoutes: RouteConfig[];
  menuTreeList: any;
}

@Module({ dynamic: true, store, name: "permission" })
class Permission extends VuexModule implements IPermissionState {
  public routes: RouteConfig[] = [];
  public dynamicRoutes: RouteConfig[] = []; //从接口获取的动态路由
  public menuTreeList:any = [];

  @Mutation
  private SET_ROUTES(routes: RouteConfig[]) {
    this.routes = [...constantRoutes, ...routes];
    this.dynamicRoutes = routes;
  }
  @Mutation
  public SET_MENUTREES(tree:any){
    this.menuTreeList = tree;
  }

  @Action
  public async GetMenus(){
    let isSchoolLogin = sessionStorage.isSchoolLogin;
    let isTeacherLogin = sessionStorage.isTeacherLogin;
    let res:any;

    if(isSchoolLogin && isSchoolLogin=="TRUE"){
      // 学校端 获取左侧菜单树
      res = await getCurrUserMenuTree();
      await this.loadPermissions()
    }
    if(isTeacherLogin && isTeacherLogin=="TRUE"){
      //  web教师端 获取左侧菜单树
      res = await teacherUserMenuTreeList();
    }
    if(res.data && res.data.length != 0){
      this.SET_MENUTREES(res.data);
    }
   
  }
  @Action
  public async loadPermissions(){
    let res = await getCurrUserResources();
    if (!res) return;
    let resources = res.data;
    let perArr:any = [];   
    for (let resource of resources) {
      perArr.push(resource.resourceCode);
    }
    var str = JSON.stringify(perArr);
    sessionStorage.setItem('permissions', str);  
    
  }

  @Action
  public GenerateRoutes(asyncRouter: any) {
    this.SET_ROUTES(asyncRouter);
  }
}

export const PermissionModule = getModule(Permission);
